"use strict";
"use client";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useToast = exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Toast = _interopRequireDefault(require("./Toast"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const ToastContext = /*#__PURE__*/(0, _react.createContext)(undefined);
const useToast = () => {
  return (0, _react.useContext)(ToastContext);
};
exports.useToast = useToast;
const defaultOptions = {
  firstToastSpace: 15,
  direction: 'top'
};
function ToastProvider(_ref) {
  let {
    children,
    options
  } = _ref;
  const [toasts, setToasts] = (0, _react.useState)([]);
  const removeToast = (0, _react.useCallback)(id => {
    if (!Boolean(id)) setToasts([]);
    setToasts(prevToasts => prevToasts.filter(toast => toast.id !== id));
  }, [toasts]);
  const addToast = (0, _react.useCallback)(options => {
    var _options$id;
    const {
      title,
      type,
      description,
      time
    } = options || {};
    const id = (_options$id = options === null || options === void 0 ? void 0 : options.id) !== null && _options$id !== void 0 ? _options$id : Date.now();
    setToasts(prevToasts => [...prevToasts, {
      id,
      title,
      type,
      description
    }]);
    setTimeout(() => removeToast(id), time || 3000);
  }, []);
  return /*#__PURE__*/_react.default.createElement(ToastContext.Provider, {
    value: {
      toasts,
      addToast,
      removeToast
    }
  }, children, /*#__PURE__*/_react.default.createElement(_Toast.default, {
    toasts: toasts,
    options: _objectSpread(_objectSpread({}, defaultOptions), options)
  }));
}
var _default = exports.default = ToastProvider;